import React, { useState, useEffect } from 'react';
import './HR.css';
import DodajPracownika from './HR/DodajPracownika';
import ListaPracownikow from './HR/ListaPracownikow';
import Absencje from './HR/Absencje';
import Zmiany from './HR/Zmiany';
import Rotacje from './HR/Rotacje';
import Grafik from './HR/Grafik';
import Grafik2 from './HR/Grafik2';

function HR({ users, projects, shifts, contracts, positions, onAddUser, onUpdateUser, onDeleteUser, onAddShift, onDeleteShift, onAddContract, onDeleteContract, onAddPosition, onDeletePosition, currentUser, employees, initialSection = 'dodaj' }) {
  const [currentSection, setCurrentSection] = useState(initialSection);
  const [rotationSubmenu, setRotationSubmenu] = useState('zmiany'); // 'zmiany' lub 'rotacje'

  useEffect(() => {
    const handleNavigate = (event) => {
      if (event.detail === 'hr-dodaj') setCurrentSection('dodaj');
      if (event.detail === 'hr-lista') setCurrentSection('lista');
      if (event.detail === 'hr-grafik') setCurrentSection('grafik');
      if (event.detail === 'hr-grafik2') setCurrentSection('grafik2');
      if (event.detail === 'hr-rotacja') setCurrentSection('rotacja');
      if (event.detail === 'hr-absencje') setCurrentSection('absencje');
    };
    window.addEventListener('navigate', handleNavigate);
    return () => window.removeEventListener('navigate', handleNavigate);
  }, []);

  // Projekty dostępne dla zalogowanego użytkownika
  const getUserProjects = () => {
    if (currentUser?.role === 'owner') {
      return projects; // Owner widzi wszystkie projekty
    }
    // Admin i Lider widzą tylko projekty, do których są przypisani
    return currentUser?.projects || [];
  };

  const availableProjects = getUserProjects();
  const isAdmin = currentUser?.role === 'admin';
  const isLider = currentUser?.role === 'lider';
  const isSuperAdmin = currentUser?.role === 'owner';


  // Tytuły sekcji
  const getSectionTitle = () => {
    switch (currentSection) {
      case 'dodaj':
        return 'Dodaj pracownika';
      case 'lista':
        return 'Lista pracowników';
      case 'grafik':
        return 'Grafik';
      case 'grafik2':
        return 'Grafik 2';
      case 'rotacja':
        return 'Rotacja';
      case 'absencje':
        return 'Absencje';
      default:
        return 'HR - Zarządzanie Pracownikami';
    }
  };

  const sectionTitle = getSectionTitle();

  return (
    <div className="hr-container">
      {sectionTitle && currentSection !== 'grafik' && currentSection !== 'grafik2' && (
        <div className="hr-header">
          <h2>{sectionTitle}</h2>
        </div>
      )}

      <div className="hr-content">
        {currentSection === 'dodaj' && currentUser && (isAdmin || isSuperAdmin) ? (
          <DodajPracownika
            users={users}
            projects={availableProjects}
            shifts={shifts || {}}
            contracts={contracts || {}}
            positions={positions || {}}
            onAddUser={onAddUser}
            onAddShift={onAddShift}
            onDeleteShift={onDeleteShift}
            onAddContract={onAddContract}
            onDeleteContract={onDeleteContract}
            onAddPosition={onAddPosition}
            onDeletePosition={onDeletePosition}
            currentUser={currentUser}
          />
        ) : currentSection === 'dodaj' ? (
          <div className="access-denied">
            <p>Brak uprawnień do dodawania pracowników. Tylko Admin i Owner mogą dodawać pracowników.</p>
            {!currentUser && <p style={{color: 'red', marginTop: '10px'}}>Błąd: Brak danych użytkownika</p>}
            {currentUser && <p style={{color: 'red', marginTop: '10px'}}>Rola użytkownika: {currentUser.role || 'nieznana'}</p>}
          </div>
        ) : null}
        {currentSection === 'lista' && (isAdmin || isLider || isSuperAdmin) && (
          <ListaPracownikow
            users={users}
            projects={availableProjects}
            contracts={contracts || {}}
            positions={positions || {}}
            onUpdateUser={onUpdateUser}
            onDeleteUser={onDeleteUser}
            currentUser={currentUser}
          />
        )}
        {currentSection === 'grafik' && (isAdmin || isLider || isSuperAdmin) && (
          <Grafik 
            projects={availableProjects}
            users={users}
            currentUser={currentUser}
            contracts={contracts || {}}
          />
        )}
        {currentSection === 'grafik2' && (isAdmin || isLider || isSuperAdmin) && (
          <Grafik2 
            projects={availableProjects}
            users={users}
            currentUser={currentUser}
            contracts={contracts || {}}
          />
        )}
        {currentSection === 'rotacja' && (
          <div className="rotacja-container">
            {(isAdmin || isLider || isSuperAdmin) ? (
              <>
                <div className="rotacja-tabs">
                  <button
                    className={`rotacja-tab ${rotationSubmenu === 'zmiany' ? 'active' : ''}`}
                    onClick={() => setRotationSubmenu('zmiany')}
                  >
                    Zmiany
                  </button>
                  <button
                    className={`rotacja-tab ${rotationSubmenu === 'rotacje' ? 'active' : ''}`}
                    onClick={() => setRotationSubmenu('rotacje')}
                  >
                    Rotacje
                  </button>
                </div>
                <div className="rotacja-content">
                  {rotationSubmenu === 'zmiany' && <Zmiany projects={availableProjects} />}
                  {rotationSubmenu === 'rotacje' && <Rotacje projects={availableProjects} />}
                </div>
              </>
            ) : (
              <div className="access-denied">
                <p>Brak uprawnień do przeglądania rotacji. Tylko Admin, Lider i Owner mają dostęp.</p>
                {!currentUser && <p style={{color: 'red', marginTop: '10px'}}>Błąd: Brak danych użytkownika</p>}
                {currentUser && <p style={{color: 'red', marginTop: '10px'}}>Rola użytkownika: {currentUser.role || 'nieznana'}</p>}
              </div>
            )}
          </div>
        )}
        {currentSection === 'absencje' && (isAdmin || isLider || isSuperAdmin) && (
          <Absencje
            users={users}
            projects={availableProjects}
            currentUser={currentUser}
          />
        )}
      </div>
    </div>
  );
}

export default HR;

